"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StayAlignedTrackerT = exports.StayAlignedTracker = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
class StayAlignedTracker {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsStayAlignedTracker(bb, obj) {
        return (obj || new StayAlignedTracker()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsStayAlignedTracker(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new StayAlignedTracker()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    yawCorrectionInDeg() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.readFloat32(this.bb_pos + offset) : 0.0;
    }
    lockedErrorInDeg() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.readFloat32(this.bb_pos + offset) : 0.0;
    }
    centerErrorInDeg() {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? this.bb.readFloat32(this.bb_pos + offset) : 0.0;
    }
    neighborErrorInDeg() {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? this.bb.readFloat32(this.bb_pos + offset) : 0.0;
    }
    locked() {
        const offset = this.bb.__offset(this.bb_pos, 12);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    static startStayAlignedTracker(builder) {
        builder.startObject(5);
    }
    static addYawCorrectionInDeg(builder, yawCorrectionInDeg) {
        builder.addFieldFloat32(0, yawCorrectionInDeg, 0.0);
    }
    static addLockedErrorInDeg(builder, lockedErrorInDeg) {
        builder.addFieldFloat32(1, lockedErrorInDeg, 0.0);
    }
    static addCenterErrorInDeg(builder, centerErrorInDeg) {
        builder.addFieldFloat32(2, centerErrorInDeg, 0.0);
    }
    static addNeighborErrorInDeg(builder, neighborErrorInDeg) {
        builder.addFieldFloat32(3, neighborErrorInDeg, 0.0);
    }
    static addLocked(builder, locked) {
        builder.addFieldInt8(4, +locked, +false);
    }
    static endStayAlignedTracker(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createStayAlignedTracker(builder, yawCorrectionInDeg, lockedErrorInDeg, centerErrorInDeg, neighborErrorInDeg, locked) {
        StayAlignedTracker.startStayAlignedTracker(builder);
        StayAlignedTracker.addYawCorrectionInDeg(builder, yawCorrectionInDeg);
        StayAlignedTracker.addLockedErrorInDeg(builder, lockedErrorInDeg);
        StayAlignedTracker.addCenterErrorInDeg(builder, centerErrorInDeg);
        StayAlignedTracker.addNeighborErrorInDeg(builder, neighborErrorInDeg);
        StayAlignedTracker.addLocked(builder, locked);
        return StayAlignedTracker.endStayAlignedTracker(builder);
    }
    unpack() {
        return new StayAlignedTrackerT(this.yawCorrectionInDeg(), this.lockedErrorInDeg(), this.centerErrorInDeg(), this.neighborErrorInDeg(), this.locked());
    }
    unpackTo(_o) {
        _o.yawCorrectionInDeg = this.yawCorrectionInDeg();
        _o.lockedErrorInDeg = this.lockedErrorInDeg();
        _o.centerErrorInDeg = this.centerErrorInDeg();
        _o.neighborErrorInDeg = this.neighborErrorInDeg();
        _o.locked = this.locked();
    }
}
exports.StayAlignedTracker = StayAlignedTracker;
class StayAlignedTrackerT {
    constructor(yawCorrectionInDeg = 0.0, lockedErrorInDeg = 0.0, centerErrorInDeg = 0.0, neighborErrorInDeg = 0.0, locked = false) {
        this.yawCorrectionInDeg = yawCorrectionInDeg;
        this.lockedErrorInDeg = lockedErrorInDeg;
        this.centerErrorInDeg = centerErrorInDeg;
        this.neighborErrorInDeg = neighborErrorInDeg;
        this.locked = locked;
    }
    pack(builder) {
        return StayAlignedTracker.createStayAlignedTracker(builder, this.yawCorrectionInDeg, this.lockedErrorInDeg, this.centerErrorInDeg, this.neighborErrorInDeg, this.locked);
    }
}
exports.StayAlignedTrackerT = StayAlignedTrackerT;
